module.exports = function getResource(label, vars = []) {
    let resources = {
        love: ' love',
        loves: ' loves'
    };

    return resources[label];
};
